import React, { useEffect, useState } from "react";
import { getPreviousBookingsAPI } from "../../../utils/APIs/bookingsApis";
import BookingsTable from "../BookingsTable/BookingsTable";
import Loader from "../../../Loader/Loader";

const LIMIT = 10;

const PreviousBookingsTable = () => {
  const [data, setData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
 const [page, setPage] = useState(() => {
   const savedPage = sessionStorage.getItem("previousBookingPage");
   return savedPage ? Number(savedPage) : 1;
 });

  useEffect(() => {
      sessionStorage.setItem("previousBookingPage", page);
    }, [page]);
  // const fetchData = async (pageNo) => {
  //   setLoading(true);
  //   try {
  //     const res = await getPreviousBookingsAPI(fromDate, toDate, pageNo, LIMIT);

  //     setData(res.data?.data || []);
  //     setTotal(res.data?.meta?.total || 0);
  //     setPage(res.data?.meta?.page || pageNo);
  //   } catch (err) {
  //     console.error("Previous bookings fetch failed", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

   const fetchData = async () => {
    setLoading(true);
    try {
      const res = await getPreviousBookingsAPI(
        fromDate,
        toDate,
        page,
        LIMIT
      );

      setData(res.data?.data || []);
      setTotal(res.data?.meta?.total || 0);
    } catch (err) {
      console.error("Previous bookings fetch failed", err);
    } finally {
      setLoading(false);
    }
  };
useEffect(() => {
 

  fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [page, fromDate, toDate]);

  const totalPages = Math.ceil(total / LIMIT);
const getPageNumbers = () => {
  let start;

  if (page <= 2) {
    start = 1;
  } else if (page >= totalPages - 1) {
    start = totalPages - 2;
  } else {
    start = page - 1;
  }

  return Array.from({ length: 3 }, (_, i) => start + i)
    .filter(p => p >= 1 && p <= totalPages);
};


  if (loading) {
    return <Loader />
  }

  return (
    <>
      {/* Filters */}
      <div className="filters">
        <div>
          <label>From Date</label>
          <input
            type="date" onClick={(e) => { if(e.target.showPicker) e.target.showPicker(); }}
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>

        <div>
          <label>To Date</label>
          <input
            type="date" onClick={(e) => { if(e.target.showPicker) e.target.showPicker(); }}
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>

        <button
          // onClick={() => fetchData(1)}
           onClick={() => setPage(1)}
          className="filter-btn"
          disabled={loading}
        >
          Apply
        </button>
      </div>

      {/* Table */}
      {/* Table */}
      <BookingsTable data={data} page={page} limit={LIMIT} type={"previous"} refetchData={fetchData}/>

      {/* Pagination */}

     {total > LIMIT && (
  <div className="pagination">
    {/* Prev */}
    <button
      className="pagination-btn"
      disabled={page === 1}
      onClick={() => setPage(page - 1)}
    >
      Prev
    </button>

    {/* Page Numbers */}
    {getPageNumbers().map((p) => (
      <button
        key={p}
        className={`pagination-btn ${p === page ? "active" : ""}`}
        onClick={() => setPage(p)}
      >
        {p}
      </button>
    ))}

    {/* Next */}
    <button
      className="pagination-btn"
      disabled={page === totalPages}
      onClick={() => setPage(page + 1)}
    >
      Next
    </button>
  </div>
)}

      
      {/* {total > LIMIT && (
        <div className="pagination">
          <button
            className="pagination-btn"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Prev
          </button>

          <span className="pagination-info">
            Page {page} of {totalPages}
          </span>

          <button
            className="pagination-btn"
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      )} */}
    </>
  );
};

export default PreviousBookingsTable;
